<template>
  <div :class="'contingencyPlan ' + 'style' + (sys_style=='2'||sys_style=='3'?'2':'')">
    <div class="message" v-show="planStatus&&!plan_id2">
      <div class="message_top">
        <span style="color: yellow">●</span>&nbsp;预案消息
      </div>
      <div class="messageList">
        <el-table
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          element-loading-text="拼命加载中"
          :data="planrunList"
          style="width: 358px; background-color: transparent"
          height="535"
          size="mini"
          :show-header="false"
          row-class-name="success-row"
        >
          <el-table-column type="index" label="" width="30">
            <template slot-scope="scope">
              <p
                @click="handleClick(scope.row)"
                :title="scope.$index + 1"
                class="messageBut-text"
                style="margin-left: 5px"
              >
                {{ scope.$index + 1 }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="" width="160">
            <template slot-scope="scope">
              <p
                :title="scope.row.name"
                @click="handleClick(scope.row)"
                class="messageBut-text"
                style="margin-left: 2px"
              >
                {{ scope.row.name }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="" width="123">
            <template slot-scope="scope">
              <p
                @click="handleClick(scope.row)"
                :title="scope.row.create_time"
                class="messageBut-text"
              >
                {{ scope.row.create_time }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="编辑" label="" width="33">
            <template slot-scope="scope">
              <button
                @click="handleClick(scope.row)"
                class="messageBut messageBut-text"
              >
                处置
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="plan" v-show="!planStatus">
      <img
        :src="picture"
        alt=""
        @mouseover="mouseover"
        @mouseleave="mouseleave"
        class="return-message"
        @click="returnMessage"
      />
      <h4
        style="
          margin: 0 15px;
          font-size: 15px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        "
        :title="clickPlanrunList.name"
      >
        {{ clickPlanrunList.name == "" ? "暂无数据" : clickPlanrunList.name }}
      </h4>
      <div class="plan_list">
        <ul>
          <div v-for="(item, index) in planrunnodeList" :key="index">
            <li
              @click="cutRight(item, index)"
              :class="planListStyle == index ? 'planList1' : 'planList'"
              v-if="item.status == 1"
            >
              <p class="plan_name">{{ item.name }}</p>
              <p style="font-size: 13px; color: #999">
                {{ item.create_time }}
              </p>
              <img
                src="../../assets/images/icons8_checkmark_yes_32px.png"
                alt=""
                style="margin-top: 16px"
                v-show="sys_style=='0'"
              />
              <img
                src="../../assets/images/style2/icon2.png"
                alt=""
                style="margin-top: 16px"
                v-show="sys_style == '2'||sys_style == '3'"
              />
              <img
                src="../../assets/images/形状 1406 拷贝 5.png"
                alt=""
                v-if="index != planrunnodeList.length - 1"
                style="top: 0; right: -84px; height: 40px; position: relative"
              />
            </li>
            <li
              @click="cutRight(item, index)"
              :class="planListStyle == index ? 'planList1' : 'planList'"
              v-if="item.status == 0 || item.status == 2"
            >
              <p class="plan_name">{{ item.name }}</p>
              <p style="font-size: 13px; color: #999">
                {{ item.create_time }}
              </p>
              <img
                src="../../assets/images/icons8_help_32px.png"
                alt=""
                style="margin-top: 16px"
                v-show="sys_style=='0'"
              />
              <img
                src="../../assets/images/style2/icon1.png"
                alt=""
                style="margin-top: 16px"
                v-show="sys_style == '2'||sys_style == '3'"
              />
              <img
                src="../../assets/images/形状 1406 拷贝 5.png"
                alt=""
                v-if="index != planrunnodeList.length - 1"
                style="top: 3px; right: -84px; height: 40px; position: relative"
                class="line"
              />
            </li>
          </div>
        </ul>
      </div>
      <el-popconfirm title="确定取消吗？" @confirm="deletePlan">
        <button class="cancel_plan" slot="reference">取消预案</button>
      </el-popconfirm>
    </div>
    <div class="planRigth" v-show="!planStatus" style="font-size: 12px">
      <div
        ref="middle"
        class="scroll-bar"
        style="height: 427px; padding: 0px 15px; margin-top: 47px; width: 287px"
      >
        <h4 style="margin-bottom: 20px">
          <span style="color: yellow">●</span>&nbsp;&nbsp;基本信息
        </h4>
        <div class="planRigth_border">
          <p class="planRigth_title">预案名称 ：</p>
          <p
            class="planRigth_title_p"
            :title="clickPlanrunList.name == '' ? '' : clickPlanrunList.name"
          >
            {{ clickPlanrunList.name == "" ? "" : clickPlanrunList.name }}
          </p>
        </div>
        <div class="planRigth_border">
          <p class="planRigth_title">预案类型 ：</p>
          <p
            class="planRigth_title_p"
            :title="
              clickPlanrunList.plan_name == '' ? '' : clickPlanrunList.plan_name
            "
          >
            {{
              clickPlanrunList.plan_name == "" ? "" : clickPlanrunList.plan_name
            }}
          </p>
        </div>
        <div class="planRigth_border">
          <p class="planRigth_title">触发来源 ：</p>
          {{
            clickPlanrunList.source == "" ? "自动触发" : clickPlanrunList.source
          }}
        </div>
        <div
          class="planRigth_border"
          v-if="clickPlanrunList.respons_name == '' ? false : true"
        >
          <p class="planRigth_title">责任人 ：</p>
          <p
            class="planRigth_title_p"
            :title="
              clickPlanrunList.respons_name == ''
                ? ''
                : clickPlanrunList.respons_name
            "
          >
            {{
              clickPlanrunList.respons_name == ""
                ? ""
                : clickPlanrunList.respons_name
            }}
          </p>
        </div>
        <div
          class="planRigth_border"
          v-if="clickPlanrunList.respons_mobile == '' ? false : true"
        >
          <p class="planRigth_title">责任人电话 ：</p>
          {{
            clickPlanrunList.respons_mobile == ""
              ? ""
              : clickPlanrunList.respons_mobile
          }}
        </div>
        <div
          class="planRigth_border"
          v-if="clickPlanrunList.publisher == '' ? false : true"
        >
          <p class="planRigth_title">上报人 ：</p>
          <p
            class="planRigth_title_p"
            :title="
              clickPlanrunList.publisher == '' ? '' : clickPlanrunList.publisher
            "
          >
            {{
              clickPlanrunList.publisher == "" ? "" : clickPlanrunList.publisher
            }}
          </p>
        </div>
        <h4 style="margin: 20px 0px">
          <span style="color: yellow">●</span>&nbsp;&nbsp;步骤明细
        </h4>
        <div>
          <div v-if="cutRightData == 1">
            <div class="planRigth_border">
              <p class="planRigth_title">流程步骤 ：</p>
              定位报警发生地
              <!-- {{
                clickPlanrunnodeList.name == ""
                  ? ""
                  : clickPlanrunnodeList.name
              }} -->
            </div>
            <div class="planRigth_border">
              <p class="planRigth_title">经度 ：</p>
              {{
                clickPlanrunList.latitude == ""
                  ? ""
                  : clickPlanrunList.longitude
              }}
            </div>
            <div class="planRigth_border">
              <p class="planRigth_title">纬度 ：</p>
              {{
                clickPlanrunList.latitude == "" ? "" : clickPlanrunList.latitude
              }}
            </div>
          </div>
          <div v-if="cutRightData == 2">
            <div class="planRigth_border">
              <p class="planRigth_title">流程步骤 ：</p>
              指派人员处理
              <!-- {{
                
                clickPlanrunnodeList.name == ""
                  ? ""
                  : clickPlanrunnodeList.name
              }} -->
            </div>
            <!-- status：0 = 未派发 1 = 已完成 -->
          </div>
          <div class="planRigth_border">
            <p class="planRigth_title">任务状态 ：</p>
            {{
              clickPlanrunnodeList.status == "0"
                ? "未派发"
                : clickPlanrunnodeList.status == "1"
                ? "已完成"
                : "待处理"
            }}
          </div>
          <div>
            <div v-if="clickPlanrunnodeList.executor_type == 0 ? true : false">
              <div
                class="planRigth_border"
                v-if="clickPlanrunnodeList.executer_id"
              >
                <p class="planRigth_title">执行人 ：</p>
                {{
                  clickPlanrunnodeList.userinfo
                    ? clickPlanrunnodeList.userinfo.name
                    : ""
                }}
              </div>
              <div
                class="planRigth_border"
                v-if="clickPlanrunnodeList.executer_id"
              >
                <p class="planRigth_title">执行人电话 ：</p>
                {{
                  clickPlanrunnodeList.userinfo
                    ? clickPlanrunnodeList.userinfo.mobile
                    : ""
                }}
              </div>
            </div>
            <div v-if="clickPlanrunnodeList.executor_type == 1 ? true : false">
              <div
                class="planRigth_border"
                v-if="clickPlanrunnodeList.executer_id"
              >
                <p class="planRigth_title">处理部门 ：</p>
                {{
                  clickPlanrunnodeList.executer
                    ? clickPlanrunnodeList.executer
                    : ""
                }}
              </div>
            </div>
          </div>

          <form action="/">
            <div v-if="clickPlanrunnodeList.executer_id">
              <!-- <p class="planRigth_title">反馈人 ：</p> -->
              <h4 style="margin: 20px 0px 15px 0px">
                <span style="color: yellow">●</span>&nbsp;&nbsp;<span
                  >反馈人</span
                >
              </h4>
              <textarea
                required="true"
                v-model="do_name"
                :class="
                  this.clickPlanrunnodeList.status == 1
                    ? 'texts disable'
                    : 'texts'
                "
              />
            </div>

            <div v-if="cutRightData == 3">
              <div class="planRigth_border">
                <p class="planRigth_title">流程步骤 ：</p>
                查看附近监控
              </div>
              <div
                v-show="videoList.length == 0"
                class="planRigth_border"
                style="justify-content: center"
              >
                附近100米暂无监控
              </div>
              <ul v-show="videoList.length > 0">
                <li v-for="(item, index) in videoList" :key="index">
                  <p @click="lookVideo(item, index)" :title="item.name">
                    {{ item.name }}
                  </p>
                  <button
                    type="button"
                    class="messageButs messageBut-texts"
                    @click="lookVideo(item, index)"
                  >
                    查看
                  </button>
                </li>
              </ul>
            </div>
            <div v-if="cutRightData == 4">
              <div class="planRigth_border">
                <p class="planRigth_title">流程步骤 ：</p>
                调用广播喊话
              </div>
              <div
                v-show="RadioList.length == 0"
                class="planRigth_border"
                style="justify-content: center"
              >
                附近50米暂无广播
              </div>
              <ul v-show="RadioList.length > 0">
                <li v-for="(item, index) in RadioList" :key="index">
                  <p @click="lookRadio(item, index)">{{ item.name }}</p>
                  <button
                    type="button"
                    class="messageButs messageBut-texts"
                    @click="lookRadio(item, index)"
                  >
                    查看
                  </button>
                </li>
              </ul>
            </div>
            <div v-if="cutRightData == 5">
              <div class="planRigth_border">
                <p class="planRigth_title">流程步骤 ：</p>
                上报预案
              </div>
            </div>
            <h4 style="margin: 20px 0px 15px 0px">
              <span style="color: yellow">●</span>&nbsp;&nbsp;<span
                >事件反馈处理</span
              >
            </h4>
            <textarea
              v-model="text"
              class="text"
              :readonly="this.clickPlanrunnodeList.status == 1 ? true : false"
            />
            <h4
              style="margin: 20px 0px"
              v-if="
                cutRightData == 5 
              "
            >
              <span style="color: yellow">●</span>&nbsp;&nbsp;上报事件
            </h4>
            <el-select
              v-model="report_id"
              value-key
              placeholder
              :allow-create="false"
              style="width: 60% !important; margin-top: 5px"
              size="mini"
              class="reportselect"
              :disabled="
                clickPlanrunnodeList.status !== 2 ||
                clickPlanrunnodeList.report_id != 0"
              v-if="
                cutRightData == 5
              "
            >
              <el-option
                v-for="item2 in reportTypes"
                :key="item2.row_id"
                :label="item2.name"
                :value="item2.row_id"
              ></el-option>
            </el-select>
            <el-button
              v-if="
                cutRightData == 5 &&
                clickPlanrunnodeList.status == 2 &&
                clickPlanrunnodeList.report_id == 0
              "
              type="primary"
              size="mini"
              class="reportbutton"
              @click="report(item)"
              style="margin-left: 10%"
              >上报</el-button
            >
            <button
              :type="controlbtn"
              class="affirm"
              @click="submit"
              v-if="
                this.clickPlanrunnodeList.status == 0 ||
                this.clickPlanrunnodeList.status == 2
              "
            >
              提交
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import request from "../../dataApi/_request";
import Api from "../../api/plancApi"
export default {
  name: "contingencyPlan",
  props: {

    videoList: {
      type: Array, // 这里你接收的值是什么类型就写什么类型
      default: '' // 接收值的默认值，如果为数组就写[]，对象就写{}
    },
    RadioList: {
      type: Array, // 这里你接收的值是什么类型就写什么类型
      default: '' // 接收值的默认值，如果为数组就写[]，对象就写{}
    },
     userdata: {
      type: Object, // 这里你接收的值是什么类型就写什么类型
      default: {} // 接收值的默认值，如果为数组就写[]，对象就写{}
    },
    sys_style:{
      type: String,
      default: '0'
    }
    // destroyedss:{
    //   type: Function,
    //   default: () => {
    //     return Function
    //   }
    // }
  },
watch: {
  videoList(newVal, oldVal){
    // newVal是新值，oldVal是旧值
    this.videoList = newVal
  },
  RadioList(newVal, oldVal){
    // newVal是新值，oldVal是旧值
    this.RadioList = newVal
    // console.log(this.RadioList,'this.RadioList');
  },
  'clickPlanrunnodeList'(newVal,oldVal){
    this.text=newVal.remark
  },
  'clickPlanrunnodeList.do_name'(newVal,oldVal){
    this.do_name=newVal
  },
  report_id(newVal,oldVal){
    if (newVal==0||newVal=='0') {
      this.report_id=""
    }
  },
},
computed: {
    mywinmap() {
      // console.log('this.$store.state.map',this.$store.state.map);
      return this.$store.state.map;
    },
  },
  data(){
    return {
         planrunList: [],
         planStatus:true,
         planrunnodeList:[],
         cutRightData:0,
         clickPlanrunList:{},
         clickPlanrunnodeList:{},
         loading:true,
         do_name:'',
         text:'',
         planListStyle:0,
         imgObj:{
          immigrate:require("../../assets/images/返回按钮1.png"),
          shift_out:require("../../assets/images/返回按钮.png"),
         },
         picture:require("../../assets/images/返回按钮.png"),
         controlbtn:'button',
         intval:null,
         positioningControl:0,
         waitExecute:null,
         quanxian:1,
         planreallyitem:null,
         plan_id2:null,
         reportTypes:[],
         report_id:"",
         planrun:[]
        }
  },
   mounted(){
    if (this.userdata.destination_id) {
       /* this.getPlianNodeDatar = setInterval(() => {
         let params = {
          method: 'get',
          url: Api.getPlanrunData,
          params:{pageNum:999999,destination_id:this.userdata.destination_id,param:{}}
          }
        request(params).then((result) => {
          let arr  = []
          result.data.list.forEach(item => {
            if(item.status == 0||item.status==1){
              arr.push(item)
            }
          })
          if (this.planListStyle==this.waitExecute) {
            this.$set(this.clickPlanrunnodeList, 'status', 2);
          }
          arr[this.waitExecute].status=2
          this.planrunList = arr
          this.$emit('getPlanrunDataNum',arr.length)
        }).catch((err) => {
        });
      }, 5000); */
    let plan_id2=window.sessionStorage.getItem("plan_id2")
    if (plan_id2) {
      this.plan_id2=plan_id2
      this.getPlanData2(plan_id2)
      window.sessionStorage.removeItem("plan_id2")
    }
      this.getPlanList()
      this.getReportType()
    } else {
      this.loading = false
    }

  },
  methods: {
    //获取上级上报类型
    getPlanrunnode(currentNodekey,num) {
      let plan_id=this.clickPlanrunList.plan_id
      let params = {
        method: 'get',
        url: Api.getPlannodeData,
        params: { param: { plan_id, order_by: "row_id asc", searchmodel: "exact" },pageNum:99999, destination_id: this.userdata.destination_id }
      }
      request(params).then((result) => {
        if (result.errcode == 0) {
          if (result.data.total != 0) {
            this.planrun = result.data.list
            let step=this.planrunnodeList.filter(item=>item.status==2)[0]
            this.report_id=this.planrun.filter(item=>item.name==step.name)[0].report_id
            
            if (this.report_id==0) {
              this.report_id=""
            }
          }
        }})},
    report(item){
     let planrun=this.planrun.filter(v=>v.name==this.clickPlanrunnodeList.name)[0]
     let {row_id,name, remark, type,task_type} =planrun
     let report_id=this.report_id
     let params = {
       method: 'get',
       url: Api.modifyPlannodeData,
       params: { row_id, data: { name, remark, type,task_type,report_id } }
     }
     request(params).then((result) => {
      if (result.errcode == 0) {
        let params = {
       method: 'get',
       url: Api.getDestination,
       params: { destination_id: this.userdata.destination_id }
     }
     request(params).then((result2) => {
    let {longitude,latitude}=this.clickPlanrunList
     name='【'+this.clickPlanrunList.name+"】-"+result2.data.list[0].name_chn+"-下级上报"
     let reporrttype=this.reportTypes.filter(v=>v.row_id==this.report_id)[0]
      let plan_id=reporrttype.plan_id
      let task_id=reporrttype.task_id
      let event_id = reporrttype.row_id
      let department_id = reporrttype.row_id
      var dispose = reporrttype.dispose
      var dispose_type = reporrttype.dispose_type
      var respons_name = reporrttype.respons_name
      var respons_mobile = reporrttype.respons_mobile
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const second = String(now.getSeconds()).padStart(2, '0');
      let report_time= `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      report_id = 0
      type=reporrttype.type
      var channel_type=2
      if (this.userdata.destination_id) {
        var source_destination_id=this.userdata.destination_id
      }else{
        var source_destination_id=this.userdata.data.destination_id
      }
      var source_planid=this.planrunnodeList.filter(v=>v.status==2)[0].planrun_id
      var source_plannodeid=this.planrunnodeList.filter(v=>v.status==2)[0].row_id
      var state=0
      var source_type=4
      let params2 = {
        method: 'get',
        url: Api.addEventmessageData,
        params: { data:{name,longitude,latitude,report_time,state,event_id,type,dispose,dispose_type,task_id,plan_id,respons_name,respons_mobile,report_id,channel_type,source_destination_id,source_planid,source_plannodeid,source_type},destination_id:this.reportTypes[0].destination_id}
      }
      request(params2).then((result) => {
       if (result.errcode==0) {
        // console.log('result :>> ', result);
        row_id=this.planrunnodeList.filter(v=>v.status==2)[0].row_id
        report_id=this.report_id
        let params3 = {
        method: 'get',
        url: Api.modifyPlanrunnodeData,
        params: { row_id, data: { report_id }
        }
      }
      request(params3).then((result) => {
        if (result.errcode==0) {
        this.$message({
                message: '上报成功',
                type: 'success',
                duration:1000
            });
            this.handleClick(this.clickPlanrunList)
            /* this.getPlanrunnodeData() */
        /* setTimeout(() => {
          this.getPlanrunnode()
        }, 500); */
        /* this.cutRight(this.planrunnodeList[index],index) */
        }else{
          this.$message.error('上报失败');
        }
      })
      
       }else{
        this.$message.error('上报失败');
       }
            })
      })
      }else{
        this.$message.error('上报失败');
      }
      
     })
    },
    getReportType(){
if (this.userdata.destination_id) {
        var params={
          method:'get',
          url:Api.getReportType,
          params:{destination_id:this.userdata.destination_id}
        }
      } else if (this.userdata.data.destination_id){
        var params={
          method:'get',
          url:Api.getReportType,
          params:{destination_id:this.userdata.data.destination_id}
        }
      }
      request(params).then((result) => {
        if (result.errcode == 0) {
          this.reportTypes = result.data.list
        } else {

        }
        // console.log(this.typedata,'this.typedata');
      }).catch((err) => {
      });
    },
    getPlanData2(plan_id2){
      let params = {
        method: 'get',
        url: Api.getPlanrunData,
        params:{pageNum:999999,destination_id:this.userdata.destination_id,
        param:{
          row_id:plan_id2
        }
        }
      }
      request(params).then((result) => {
        if (result.errcode==0) {
          this.handleClick(result.data.list[0])
        }
      })
    },
    mouseover(){
      this.picture = this.imgObj.immigrate;
    },
    mouseleave(){
      this.picture = this.imgObj.shift_out;
    },
    getPlanList(){
       let params = {
        method: 'get',
        url: Api.getPlanrunData,
        params:{pageNum:999999,destination_id:this.userdata.destination_id}
      }
      request(params).then((result) => {
        let arr  = []
        result.data.list.forEach(item => {
          if(item.status == 0||item.status == 1){
            arr.push(item)
          }
        })
        this.planrunList = arr
        if (this.quanxian == 2) {
          this.planrunnodeList[this.waitExecute].status = 2
          this.quanxian = 1
        }
        //  console.log(123,arr.length);
        this.$emit('getPlanrunDataNum',arr.length)
        let plan_id=window.sessionStorage.getItem("plan_id")
        if (plan_id) {
          for (let i = 0; i < this.planrunList.length; i++) {
            if (this.planrunList[i].row_id == plan_id) {
              this.handleClick(this.planrunList[i])
              window.sessionStorage.removeItem("plan_id")
            }
          }
        }
        if (result.errcode == 0) {
          this.loading = false
        } else {
          this.loading = true
        }
      }).catch((err) => {
      });
    },
    handleClick(row) {

      setTimeout(() => {
        this.planStatus = false
        this.clickPlanrunList = row
        // console.log(this.clickPlanrunList,'this.clickPlanrunList');
        this.getPlanrunnodeData(row.row_id)
        this.$emit('handlePlan',row,2)
        this.getPlanrunnodeDatas(row.row_id)
        // console.log('2345 :>> ', 2345);
        setTimeout(() => {
           this.getPlanrunnode()
        }, 500);
       
        this.$emit('clicklistdata', row);
      }, 200);
    },    
    getPlanrunnodeData(planrun_id){
      // console.log('planrun_id',planrun_id);
      let params = {
        method: 'get',
        url: Api.getPlanrunnodeData,
        params: {param:{planrun_id, "order_by":"order_number asc",searchmodel:"exact"},destination_id:this.userdata.destination_id}
      }
      request(params).then((result) =>{
        this.planrunnodeList = result.data.list
        for (let w = 0; w < this.planrunnodeList.length; w++) {
          if (this.planrunnodeList[w].status == 1) {
            continue;
          }
          // this.planrunnodeList[w].status = 2
          this.waitExecute = w
          if (this.planrunnodeList[w].status == 0) {
            break;
          }
        }
        // console.log('this.planrunnodeList :>> ', this.planrunnodeList);
        // console.log('this.planrunnodeList',this.planrunnodeList);
        this.clickPlanrunnodeList = {}
        // console.log('this.clickPlanrunnodeList3 :>> ', this.clickPlanrunnodeList);
        if(result.data.list != ''){
          for(let i = 0 ; i < result.data.list.length; i++){
            if(!result.data.list[i].status){
              result.data.list[i].latitude = this.clickPlanrunList.latitude
              result.data.list[i].longitude = this.clickPlanrunList.longitude
              // console.log(result,'result');\
                this.cutRight(result.data.list[i],i)
                this.clickPlanrunnodeList = this.planrunnodeList[i]
                // console.log('this.clickPlanrunnodeList :>> 4', this.clickPlanrunnodeList);
                this.positioningControl = this.clickPlanrunnodeList.order_number
                // console.log('this.positioningControl2 :>> ', this.positioningControl);
                  //获取执行人信息
                  if (this.clickPlanrunnodeList.executor_type == 0) {
                    if(this.clickPlanrunnodeList.executer_id){
                      this.getUserInfo(this.clickPlanrunnodeList.executer_id)
                    }
                  }
              return;
            }
          }
          if (result.data.list.filter((item) => item.status!=1).length ==0 ){
              // console.log(result,'result');\
                this.cutRight(result.data.list[0],0)
                this.clickPlanrunnodeList = this.planrunnodeList[0]
                // console.log('this.clickPlanrunnodeList :>>5 ', this.clickPlanrunnodeList);
                this.positioningControl = this.clickPlanrunnodeList.order_number
                // console.log('this.positioningControl1 :>> ', this.positioningControl);
                  //获取执行人信息
                  if (this.clickPlanrunnodeList.executor_type == 0) {
                    if(this.clickPlanrunnodeList.executer_id){
                      this.getUserInfo(this.clickPlanrunnodeList.executer_id)
                    }
                  }
              return;
          }
          
        }

      }).catch((err) => {
      });
    },
    getPlanrunnodeDatas(planrun_id){
    clearInterval(this.intval)
      this.intval = setInterval(() => {
        let params = {
          method: 'get',
          url: Api.getPlanrunnodeData,
          params: {param:{planrun_id, "order_by":"order_number asc",searchmodel:"exact"},destination_id:this.userdata.destination_id}
        }
        request(params).then((result) =>{
          if (result.data.list) {
            // this.waitExecute = -1
            this.planrunnodeList = result.data.list
            this.clickPlanrunnodeList=this.planrunnodeList[this.planListStyle]
            if (this.planListStyle==this.waitExecute&&this.clickPlanrunnodeList.status==0) {
            this.$set(this.clickPlanrunnodeList, 'status', 2);
            }
            if (result.data.list[this.positioningControl - 1].status == 1) {
              if (result.data.filter(v=>v.status!==1).length==0) {
                return
              }
              
              this.clickPlanrunnodeList = {}
              // console.log('this.clickPlanrunnodeList :>> 6', this.clickPlanrunnodeList);
              // console.log('result.data :>> ', result.data);
              if(result.data.list != ''){
                for(let i = 0 ; i < result.data.list.length; i++){
                  if(!result.data.list[i].status){
                    result.data.list[i].latitude = this.clickPlanrunList.latitude
                    result.data.list[i].longitude = this.clickPlanrunList.longitude
                      this.cutRight(result.data.list[i],i)
                      this.clickPlanrunnodeList = this.planrunnodeList[i]
                      // console.log('this.clickPlanrunnodeList :>>7 ', this.clickPlanrunnodeList);
                      this.positioningControl = this.clickPlanrunnodeList.order_number
                      // console.log('this.positioningControl3 :>> ', this.positioningControl);
                        //获取执行人信息
                        if (this.clickPlanrunnodeList.executor_type == 0) {
                          if(this.clickPlanrunnodeList.executer_id){
                            this.getUserInfo(this.clickPlanrunnodeList.executer_id)
                          }
                        }
                    return;
                  }
                }
              }
            if (this.planrunnodeList[this.planrunnodeList.length-1].status == 1) {
              if (!this.plan_id2) {
                this.returnMessage()
              }
            }

            }

          }
        }).catch((err) => {
        });
      }, 5000);
    },
    cutRight(item,index){
        if (window.popup1) {
        window.popup1.close()
      }
      for (let i = 0; i < this.planrunnodeList.length; i++) {
        if (this.planrunnodeList[i].status == 0 || this.planrunnodeList[i].status == 2) {
          this.waitExecute = i
          break;
        }
      }
      if (item.type == 1) {
        let params = {
        method: 'get',
        url: Api.getPlanrunData,
        params:{pageNum:999999,destination_id:this.userdata.destination_id,param:{row_id:item.planrun_id}}
        }
        request(params).then((result) => {
          if (result.errcode == 0) {
            let arr  = []
            result.data.list.forEach(item => {
              if(item.status == 0||item.status==1){
                arr.push(item)
              }
            })
            this.planreallyitem = arr
            this.planreallyitem = this.planreallyitem[0]||[]
            this.planreallyitem.type = 1
            this.do_name=''
            this.text=''
            if (this.waitExecute == index) {
              item.status = 2
            }
            this.clickPlanrunnodeList = item
            // console.log('this.clickPlanrunnodeList1 :>> ', this.clickPlanrunnodeList);
            this.planListStyle = index
            this.$emit('handlePlan',this.planreallyitem,0)
            setTimeout(() => {
          this.getPlanrunnode()
          // console.log('222 :>> ', 222);
        }, 500);
          }
        }).catch((err) => {
        });
      } else {
        this.do_name=''
        this.text=''
        if (this.waitExecute == index) {
          item.status = 2
        }
        if (!this.report_id) {
          this.report_id = item.report_id
        }
        this.clickPlanrunnodeList = item
        // console.log('this.clickPlanrunnodeList2 :>> ', this.clickPlanrunnodeList);
        this.planListStyle = index

        if(
        item.type == 2
      ){
        item.longitude=this.clickPlanrunList.longitude
        item.latitude=this.clickPlanrunList.latitude
      }
        if (item.type!=3&&item.type!=4) {
          this.$emit('handlePlan',item,0)
        }
        if (item.type == 3) {
          this.$emit('handlePlan',item,1,index)
        }
        if (item.type==4) {
          this.$emit('handlePlan',item,3,index)
        }
      }
      this.cutRightData = item.type
       //获取执行人信息
        if (this.clickPlanrunnodeList.executor_type == 0) {
          if(this.clickPlanrunnodeList.executer_id){
            this.getUserInfo(this.clickPlanrunnodeList.executer_id)
          }
        }
        
    },




    getUserInfo(row_id){
      // console.log('row_id',row_id);
       let params = {
        method: 'get',
        url: Api.getTableData,
        params: {data:{row_id:row_id,searchmodel:"exact"},destination_id:this.userdata.destination_id}
        }   
        request(params).then((result) =>{
          // console.log('getuser',result.data.list);

          this.clickPlanrunnodeList.userinfo=result.data.list[0]


        }).catch((err) => {  });
    },




    returnMessage(){
      this.plan_id2=null
      clearInterval(this.intval)
      if (window.popup1) {
        window.popup1.close()
      }
      
      this.planStatus = true
      this.$emit('clearMarkerMap')
      
    },
    lookVideo(item,index){
      this.$emit('listClick',"video",index)
    },
    lookRadio(item,index){
      this.$emit('handlePlan',item,3,index)
      this.$emit('listClick',"radio",index)
    },
    submit(){
      // console.log('this.clickPlanrunnodeList',this.clickPlanrunnodeList);
      // console.log(this.planrunnodeList,'sssssxxxxx',this.planrunnodeList[this.planrunnodeList.length-1]);
      // console.log(this.clickPlanrunnodeList.order_number);
      let planrun_id = this.clickPlanrunList.row_id
      let runnode_id = this.clickPlanrunnodeList.row_id
      let status = 1
      let remark = this.text
      let do_name = this.do_name
      if (this.clickPlanrunnodeList.status == 2) {

        // 更改status状态名称   0 未派发  1 已处理 2 待处理  （状态 2 为本地代码新增，数据库只有状态  0  1 ）

        if (!this.clickPlanrunnodeList.executer_id) {
          this.controlbtn = 'button'
          if (this.waitExecute+1 <= this.planrunnodeList.length) {
            this.waitExecute = this.waitExecute + 1
            this.quanxian = 2
            for (let w = 0; w < this.planrunnodeList.length; w++) {
              if (this.planrunnodeList[w].status == 2) {
                this.planrunnodeList[w].status = 1
              }
            }
          }
          let params = {
            method: 'get',
            url: Api.UpdataPlanstatus,
            params: {planrun_id,runnode_id,status,remark}
          }
          request(params).then((result) => {
            if(result.errcode == 0){
              this.$message({
                message: '保存成功',
                      type: 'success',
                      duration:1000,
                      showClose:true
              });
              for(let i=0;i<this.planrunnodeList.length;i++){

                if(this.planrunnodeList[i].row_id === this.clickPlanrunnodeList.row_id ){
                  setTimeout(() => {
                  if( this.planrunnodeList.length-1 !== i){
                  let params = {
                      method: 'get',
                      url: Api.getPlanrunnodeData,
                      params: {param:{planrun_id:this.clickPlanrunList.row_id,searchmodel:"exact","order_by":"order_number asc"},destination_id:this.userdata.destination_id}
                    }
                    request(params).then((result) => {
                        this.planrunnodeList = result.data.list
                        // console.log('2020201',this.planrunnodeList);
                    }).catch((err) => {
                    });
                    this.clickPlanrunnodeList = this.planrunnodeList[i+1]
                    this.cutRightData = this.clickPlanrunnodeList.type
                  }else{
                    let params = {
                      method: 'get',
                      url: Api.getPlanrunnodeData,
                      params: {param:{planrun_id:this.clickPlanrunList.row_id,searchmodel:"exact","order_by":"order_number asc"},destination_id:this.userdata.destination_id}
                    }
                    request(params).then((result) => {
                        this.planrunnodeList = result.data.list
                        // console.log('202020',this.planrunnodeList);
                    }).catch((err) => {
                    });
                  }
                }, 1500);
                  // console.log('当前为',this.clickPlanrunnodeList);
                  for (let index = this.planListStyle+1; index < this.planrunnodeList.length; index++) {
                    if (this.planrunnodeList[index].status!==1) {
                      setTimeout(() => {
                        this.cutRight(this.planrunnodeList[index],index)
                      }, 1500);
                      break
                    }
                  }
                  break
                }
              }
              if (this.planrunnodeList[this.planrunnodeList.length-1].row_id==this.clickPlanrunnodeList.row_id) {
                if (!this.plan_id2) {
                this.returnMessage()
              }
                // console.log('退出了');
              }
            }else{
              this.$message.error('保存失败');
            }
          }).catch((err) => {
          });
        } else {
          if (do_name == '') {
            this.controlbtn = 'submit'
            let middle= this.$refs["middle"];
            middle.scrollTop = middle.scrollHeight;
          } else {
            this.controlbtn = 'button'
            let params = {
              method: 'get',
              url: Api.UpdataPlanstatus,
              params: {planrun_id,runnode_id,status,remark,do_name}
            }
            request(params).then((result) => {
              if(result.errcode == 0){
                this.$message({
                  message: '保存成功',
                        type: 'success',
                        duration:1000,
                        showClose:true
                });
                for(let i=0;i<this.planrunnodeList.length;i++){
                  if(this.planrunnodeList[i].row_id === this.clickPlanrunnodeList.row_id ){
                    setTimeout(() => {
                    if( this.planrunnodeList.length-1 !== i){
                    let params = {
                        method: 'get',
                        url: Api.getPlanrunnodeData,
                        params: {param:{planrun_id:this.clickPlanrunList.row_id,searchmodel:"exact","order_by":"order_number asc"},destination_id:this.userdata.destination_id}
                      }
                      request(params).then((result) => {
                          this.planrunnodeList = result.data.list
                          // console.log('2020201',this.planrunnodeList);
                      }).catch((err) => {
                      });
                      this.clickPlanrunnodeList = this.planrunnodeList[i+1]
                      this.cutRightData = this.clickPlanrunnodeList.type
                    }else{
                      let params = {
                        method: 'get',
                        url: Api.getPlanrunnodeData,
                        params: {param:{planrun_id:this.clickPlanrunList.row_id,searchmodel:"exact","order_by":"order_number asc"},destination_id:this.userdata.destination_id}
                      }
                      request(params).then((result) => {
                          this.planrunnodeList = result.data.list
                          // console.log('202020',this.planrunnodeList);
                      }).catch((err) => {
                      });
                    }
                  }, 1500);
                    // console.log('当前为',this.clickPlanrunnodeList);
                    for (let index = this.planListStyle+1; index < this.planrunnodeList.length; index++) {
                      if (this.planrunnodeList[index].status!==1) {
                        
                        setTimeout(() => {
                        this.cutRight(this.planrunnodeList[index],index)
                        // console.log('nononononono',this.planrunnodeList[index]);
                        }, 2000);
                        break
                      }
                    }
                    break
                  }
                }
              if (this.planrunnodeList[this.planrunnodeList.length-1].row_id==this.clickPlanrunnodeList.row_id) {
                if (!this.plan_id2) {
                this.returnMessage()
              }
                // console.log('退出了');
              }
              }else{
                this.$message.error('保存失败');
              }
            }).catch((err) => {
          });
        }
        }
        this.getPlanList()

      } else {
        this.$message("请按照顺序提交")
      }
    },
    deletePlan(){
      let params = {
        method: 'get',
        url: Api.deletePlanrunData,
        params: {row_id:this.clickPlanrunList.row_id}
      }
        request(params).then((result) => {
           if(result.errcode == 0){
          this.$message({
                message: '删除成功',
                type: 'success',
            duration:1000
          });
          this.getPlanList()
          this.planStatus = true
        }else{
          this.$message.error('删除失败');
        } 
        }).catch((err) => {
        });
        
        this.$emit('clearMarkerMap')
    }

  },
  beforeDestroy(){
    this.returnMessage()
  },
 
};
</script>
<style lang="scss" scoped>
.plan li {
  padding-top: 10px;
  margin-bottom: 30px;
  height: 69px;
  width: 220px;
  margin-left: 18px !important;
  list-style: none;
  background-size: 100% 100%;
  color: #35d2d2;
  p {
    text-align: center;
    margin: 8px;
  }
  img {
    position: relative;
    top: -84px;
    right: -200px;
  }
}
</style>
<style lang="scss">
.contingencyPlan {
  width: 1px;
  height: 748px;
  margin: 0;
  &.style2 {
    .reportselect {
    .el-input__inner {
      background-color: transparent !important;
      border: 1px solid #105e4e !important;
      color: #fff !important;
    }
  }
    .messageList {
      background-image: url("../../assets/images/style2/bigbg.png");
    }
    .plan {
      background-image: url("../../assets/images/style2/bg.png") !important;
    }
    .planRigth {
      background-image: url("../../assets/images/style2/yjbg.png") !important;
      .planRigth_border {
        border-color: #105e4e !important;
      }
      ul{
        border-color: #105e4e !important;
      }
      .messageButs{
        color: #ffffff!important;
      }
      .text {
        border-color: #105e4e !important;
        background-color: rgba($color: #021a15, $alpha: 0.5);
      }
      .texts {
        border-color: #105e4e !important;
        background-color: rgba($color: #021a15, $alpha: 0.5);
      }
      .affirm {
        background-color: rgba($color: #063a31, $alpha: 0.5) !important;
        border: 1px solid #68ffe0 !important;
        &:hover {
          border-color: #ff9920 !important;
          color: #ff9920 !important;
        }
      }
    }
    .planList {
      background-image: url("../../assets/images/style2/border.png") !important;
      &:hover {
        background-image: url("../../assets/images/style2/borderhover.png") !important;
        .plan_name {
          color: #ff9920 !important;
        }
      }
    }
    .planList1 {
      background-image: url("../../assets/images/style2/borderhover.png") !important;
      .plan_name {
        color: #ff9920 !important;
      }
    }
    .cancel_plan {
      background-color: rgba($color: #063a31, $alpha: 0.5) !important;
      border: 1px solid #68ffe0 !important;
      &:hover {
        border-color: #ff9920 !important;
        color: #ff9920 !important;
      }
    }
  }
}

.message {
  width: 365px;
  height: 680px;
  position: absolute;
  left: 60px;
}

.messageList {
  width: 365px;
  padding: 5px 0 0 5px;
  height: 550px;
  background-image: url("../../assets/images/矩形 691.png");
  background-size: 365px 549px;
  opacity: 1;
}
.message_top {
  color: #fff;
  height: 35px;
  width: 124px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background-image: url("../../assets/images/组 186.png");
}

.contingencyPlan {
  .plan {
    width: 280px;
    padding-top: 20px;
    height: 530px;
    background: no-repeat;
    background-image: url("../../assets/images/一键报警预案.png");
    background-size: 280px 530px;
    opacity: 1;
    position: absolute;
    top: 60px;
    left: 25px;
  }
}

.return-message {
  position: absolute;
  top: -60px;
  left: 25px;
}
.return-message:hover {
  cursor: pointer;
}

.contingencyPlan {
  .plan ul {
    margin: 10px 0px 10px 10px;
    width: 280px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden !important;
    &::-webkit-scrollbar {
      width: 10px;
      background-color: rgba(0, 0, 0, 1);
    }

    &::-webkit-scrollbar-button {
      width: 10px;
      height: 15px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-button:start:decrement {
      background: url("../../assets/images/scrollbarStart.jpg") no-repeat !important;
    }

    &::-webkit-scrollbar-button:end:increment {
      display: block;
      background: url("../../assets/images/scrollbarEnd.jpg") no-repeat !important;
      transform: rotate(180deg);
    }

    &::-webkit-scrollbar-button:vertical:start:increment,
    ::-webkit-scrollbar-button:vertical:end:decrement {
      display: none;
    }

    &::-webkit-scrollbar-corner {
      display: block;
    }

    /*滚动条颜色*/

    &::-webkit-scrollbar-thumb {
      background-clip: padding-box;
      /* background-color: #1ac4c8; */
      border-radius: 50px;
      opacity: 0.5;
      background: url("../../assets/images/scrollbarEndthumb.jpg");
    }

    &::-webkit-scrollbar-thumb:hover {
      background-clip: padding-box;
      background-color: #1ac4c8;
      border-radius: 50px;
      opacity: 0.5;
      background: url("../../assets/images/scrollbarEndthumb.jpg");
    }

    /*滚动条背景色*/

    &::-webkit-scrollbar-track {
      background-clip: padding-box;
      background-color: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-track:hover {
      background-clip: padding-box;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 8px;
    }

    &::-webkit-scrollbar-track:vertical,
    ::-webkit-scrollbar-thumb:vertical {
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
    }

    &::-webkit-scrollbar-track:horizontal,
    ::-webkit-scrollbar-thumb:horizontal {
      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;
    }

    &::-webkit-scrollbar-track:hover {
      background-clip: padding-box;
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
}

.plan li {
  padding-top: 10px;
  margin-bottom: 30px;
  height: 69px;
  width: 220px;
  list-style: none;
  background-size: 100% 100%;
  color: #35d2d2;
  p {
    text-align: center;
    margin: 8px;
  }
  img {
    position: relative;
    top: -84px;
    right: -220px;
  }
}
.plan .plan_list {
  width: 274.5px;
  height: 399px;
  /* margin-top: 23px; */
  margin-bottom: 33px;
  display: flex;
  justify-content: center;
}
.plan h4 {
  color: #fff;
  text-align: center;
  margin-top: 6px;
}

.planRigth {
  width: 290px;
  height: 565px;
  background: no-repeat;
  background-image: url("../../assets/images/预警信息.png");
  background-size: 290px 565px;
  opacity: 1;
  position: fixed;
  right: 30px;
  top: 93px;
  color: #fff;
  .reportselect {
    .el-input__inner {
      background-color: transparent !important;
      border: 1px solid #15498b !important;
      color: #fff !important;
    }
  }
  .planRigth_border {
    border: 1px solid #15498b;
    display: flex;
    margin-bottom: 10px;
    padding: 2px 0;
    line-height: 20px;
    height: 29px;
    .planRigth_title {
      color: #aaa;
      width: 90px;
      margin-left: 20px;
    }
    .planRigth_title_p {
      overflow: hidden;
      width: 166px;
      height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .planRigth_title_p:hover {
      cursor: pointer;
    }
  }
  .text {
    width: 100%;
    height: 72px;
    border: 1px solid #15498b;
    background-color: #062451;
    color: #fff;
    padding: 5px;
    opacity: 0.9;
    resize: none;
    margin-bottom: 10px;
    &.disable {
      pointer-events: none;
    }
  }
  .texts {
    width: 100%;
    height: 29px;
    border: 1px solid #15498b;
    background-color: #062451;
    color: #fff;
    padding: 5px;
    opacity: 0.9;
    resize: none;
    &.disable {
      pointer-events: none;
    }
  }
  .text:checked {
    border: 1px solid #15498b;
  }
  .affirm {
    // margin-top: 20px;
    // margin-left: 98px;
    top: 600px;
    right: 145px;
    position: fixed;
    width: 60px;
    height: 25px;
    border: 1px solid #07eeed;
    background-color: #062451;
    opacity: 0.9;
    color: #fff;
    cursor: pointer;
    &:hover {
      border-color: yellow;
      color: yellow;
    }
  }
  ul,
  li {
    margin: 0;
    list-style: none;
  }
  li {
    display: flex;
    padding: 3px 0;
    p {
      width: 170px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  li:hover {
    color: yellow;
    cursor: pointer;
  }

  ul {
    border: 1px solid #15498b;
    padding: 10px 20px;
    margin-bottom: 15px;
  }

  .contingencyPlan {
    .scroll-bar {
      overflow-y: auto;
      height: calc(100% - 35px);
      &::-webkit-scrollbar {
        width: 10px;
        background-color: rgba(0, 0, 0, 1);
      }

      &::-webkit-scrollbar-button {
        width: 10px;
        height: 15px;
        cursor: pointer;
      }

      &::-webkit-scrollbar-button:start:decrement {
        background: url("../../assets/images/scrollbarStart.jpg") no-repeat !important;
      }

      &::-webkit-scrollbar-button:end:increment {
        display: block;
        background: url("../../assets/images/scrollbarEnd.jpg") no-repeat !important;
        transform: rotate(180deg);
      }

      &::-webkit-scrollbar-button:vertical:start:increment,
      ::-webkit-scrollbar-button:vertical:end:decrement {
        display: none;
      }

      &::-webkit-scrollbar-corner {
        display: block;
      }

      /*滚动条颜色*/

      &::-webkit-scrollbar-thumb {
        background-clip: padding-box;
        /* background-color: #1ac4c8; */
        border-radius: 50px;
        opacity: 0.5;
        background: url("../../assets/images/scrollbarEndthumb.jpg");
      }

      &::-webkit-scrollbar-thumb:hover {
        background-clip: padding-box;
        background-color: #1ac4c8;
        border-radius: 50px;
        opacity: 0.5;
        background: url(../../assets/images/scrollbarEndthumb.jpg);
      }

      /*滚动条背景色*/

      &::-webkit-scrollbar-track {
        background-clip: padding-box;
        background-color: transparent;
        border-radius: 8px;
      }

      &::-webkit-scrollbar-track:hover {
        background-clip: padding-box;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 8px;
      }

      &::-webkit-scrollbar-track:vertical,
      ::-webkit-scrollbar-thumb:vertical {
        border-left: 1px solid transparent;
        border-right: 1px solid transparent;
      }

      &::-webkit-scrollbar-track:horizontal,
      ::-webkit-scrollbar-thumb:horizontal {
        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;
      }

      &::-webkit-scrollbar-track:hover {
        background-clip: padding-box;
        background-color: rgba(0, 0, 0, 0.15);
      }
    }
  }
}

.messageBut-text:hover {
  text-decoration: underline !important;
}

.messageBut-texts {
  &:hover {
    text-decoration: underline !important;
    border-color: yellow;
    color: yellow;
  }
}
.scroll-bar {
  margin-top: 10px;
}
.messageBut {
  background-color: transparent;
  color: #35d2d2 !important;
  border: none;
}
.messageButs {
  background-color: transparent;
  color: #35d2d2;
  border: none;
  cursor: pointer;
}
.cancel_plan {
  background-color: #0f2c4e;
  color: #fff;
  font-size: 12px;
  border: 1px solid #35d2d2;
  position: relative;
  top: -75px;
  left: 105px;
  height: 29px;
  width: 80px;
  cursor: pointer;
  &:hover {
    border-color: yellow;
    color: yellow;
  }
}
.planList {
  font-size: 14px;
  background-image: url("../../assets/images/组 222 拷贝 5.png");
}
.planList:hover {
  cursor: pointer;
  background-image: url("../../assets/images/组 222 拷贝 3.png") !important;
  .plan_name {
    color: yellow;
  }
}
.planList1 {
  font-size: 14px;
  background-image: url("../../assets/images/组 222 拷贝 3.png");
  .plan_name {
    color: yellow;
  }
}
.planList1:hover {
  cursor: pointer;
}
</style>
<style lang="scss">
.contingencyPlan {
  .el-table .success-row {
    background-color: transparent !important;
    color: #35d2d2;
  }
  // .el-table--scrollable-x .el-table__body-wrapper{
  //   overflow-x: hidden;
  // }
  .el-table__body-wrapper {
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 10px;
      background-color: rgba(0, 0, 0, 1);
    }

    &::-webkit-scrollbar-button {
      width: 10px;
      height: 15px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-button:start:decrement {
      background: url("../../assets/images/scrollbarStart.jpg") no-repeat !important;
    }

    &::-webkit-scrollbar-button:end:increment {
      display: block;
      background: url("../../assets/images/scrollbarEnd.jpg") no-repeat !important;
      transform: rotate(180deg);
    }

    &::-webkit-scrollbar-button:vertical:start:increment,
    ::-webkit-scrollbar-button:vertical:end:decrement {
      display: none;
    }

    &::-webkit-scrollbar-corner {
      display: block;
    }

    /*滚动条颜色*/

    &::-webkit-scrollbar-thumb {
      background-clip: padding-box;
      /* background-color: #1ac4c8; */
      border-radius: 50px;
      opacity: 0.5;
      background: url("../../assets/images/scrollbarEndthumb.jpg");
    }

    &::-webkit-scrollbar-thumb:hover {
      background-clip: padding-box;
      background-color: #1ac4c8;
      border-radius: 50px;
      opacity: 0.5;
      background: url("../../assets/images/scrollbarEndthumb.jpg");
    }

    /*滚动条背景色*/

    &::-webkit-scrollbar-track {
      background-clip: padding-box;
      background-color: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-track:hover {
      background-clip: padding-box;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 8px;
    }

    &::-webkit-scrollbar-track:vertical,
    ::-webkit-scrollbar-thumb:vertical {
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
    }

    &::-webkit-scrollbar-track:horizontal,
    ::-webkit-scrollbar-thumb:horizontal {
      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;
    }

    &::-webkit-scrollbar-track:hover {
      background-clip: padding-box;
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
  .success-row {
    td {
      div {
        padding: 0 0px !important;
        p {
          overflow: hidden;
          width: 155px;
          height: 23px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    td:hover {
      cursor: pointer;
    }
  }
  .success-row th,
  .success-row td,
  .success-row tr {
    border: none !important;
    background-color: transparent;
  }
  .success-row:hover > td {
    color: yellow !important;
    background-image: url("../../assets/images/矩形 1547.png") !important;
    background-color: transparent !important;
    opacity: 1;
    .messageBut {
      color: yellow !important;
    }
  }

  .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px !important;
  }
}
@media screen and(max-width: 1400px) {
  .planRigth .affirm{
    top: 515px;
    right: 120px;
  }
  .contingencyPlan .plan {
    width: 250px;
    padding-top: 20px;
    height: 480px;
    background-size: 100% 100%;
}
.contingencyPlan .planRigth {
    width: 240px;
    height: 515px;
    background-size: 100% 100%;
}
.contingencyPlan .scroll-bar{
  height: 400px!important;
    width: 237px!important;
}
.plan .plan_list {
    width: 240px;
    height: 380px;
    margin-bottom: 33px;
}
.contingencyPlan .plan ul{
  width: 240px;
}
.contingencyPlan .plan li {
    padding-top: 13px;
    margin-bottom: 30px;
    height: 69px;
    width: 194px;
    margin-left: 18px !important;
    list-style: none;
    background-size: 100% 100%;
    color: #35d2d2;
    .line{
      top: -2px!important;
    right: -74px!important;
    }
}
.contingencyPlan .plan li img {
    position: relative;
    top: -84px;
    right: -175px;
}
.cancel_plan {
    top: -65px;
    left: 90px;
}
}

// @media only screen and (max-width: 1400px) {
//   .plan li {
//     height: 60px;
//     margin-bottom: 25px;
//     margin-top: 9px;
//     p {
//       margin: 5px;
//     }
//     img:nth-of-type(1) {
//       margin-top: 21px;
//     }
//     img:nth-of-type(2) {
//       height: 24px;
//     }
//   }
//   .return-message {
//     position: absolute;
//     top: -39px;
//     left: 20px;
//     width: 97px;
//   }
//   /* .cancel_plan {
//     top: -50px !important;
//   } */
//   .planRigth .planRigth_border {
//     margin-bottom: 4px;
//     padding: 5px 0;
//   }
//   .scroll-bar {
//     /* margin-top: 39px !important; */

//     h4:nth-of-type(1) {
//       margin-bottom: 10px !important;
//     }
//     h4:nth-of-type(2) {
//       margin: 10px !important;
//     }
//     .planRigth .planRigth_border {
//       font-size: 12px;
//     }
//   }
//   .hideback .contingencyPlan .plan {
//     top: 55px !important;
//   }
//   .planRigth {
//     top: 40px;
//   }
//   .planRigth .affirm {
//     top: 540px;
//   }
// }
</style>


